import FormattedMessage from 'I18n/components/FormattedMessage';
import { ExpandingFAQ, FrequentlyAskedQuestionsContainer } from './FrequentlyAskedQuestions';
import { useFaqToggleHandler } from './FrequentlyAskedQuestionsUtils';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const FreeToolsFAQs = ({
  onFaqInteraction
} = {}) => {
  const handleFaqToggle = useFaqToggleHandler(onFaqInteraction);
  return /*#__PURE__*/_jsxs(FrequentlyAskedQuestionsContainer, {
    children: [/*#__PURE__*/_jsx(ExpandingFAQ, {
      Title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "pricing-page-components.frequentlyAskedQuestions.freeTools.whatAreLimits.question"
      }),
      Content: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "pricing-page-components.frequentlyAskedQuestions.freeTools.whatAreLimits.answer"
      }),
      onExpandedChange: () => handleFaqToggle('freeTools.whatAreLimits', 'pricing-page-components.frequentlyAskedQuestions.freeTools.whatAreLimits.question')
    }), /*#__PURE__*/_jsx(ExpandingFAQ, {
      Title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "pricing-page-components.frequentlyAskedQuestions.freeTools.emailIntegration.question"
      }),
      Content: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "pricing-page-components.frequentlyAskedQuestions.freeTools.emailIntegration.answer"
      }),
      onExpandedChange: () => handleFaqToggle('freeTools.emailIntegration', 'pricing-page-components.frequentlyAskedQuestions.freeTools.emailIntegration.question')
    }), /*#__PURE__*/_jsx(ExpandingFAQ, {
      Title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "pricing-page-components.frequentlyAskedQuestions.freeTools.howManyContacts.question"
      }),
      Content: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "pricing-page-components.frequentlyAskedQuestions.freeTools.howManyContacts.answer"
      }),
      onExpandedChange: () => handleFaqToggle('freeTools.howManyContacts', 'pricing-page-components.frequentlyAskedQuestions.freeTools.howManyContacts.question')
    }), /*#__PURE__*/_jsx(ExpandingFAQ, {
      Title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "pricing-page-components.frequentlyAskedQuestions.freeTools.whatSupport.question"
      }),
      Content: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "pricing-page-components.frequentlyAskedQuestions.freeTools.whatSupport.answer"
      }),
      onExpandedChange: () => handleFaqToggle('freeTools.whatSupport', 'pricing-page-components.frequentlyAskedQuestions.freeTools.whatSupport.question')
    }), /*#__PURE__*/_jsx(ExpandingFAQ, {
      Title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "pricing-page-components.frequentlyAskedQuestions.freeTools.whatDiscounts.question"
      }),
      Content: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "pricing-page-components.frequentlyAskedQuestions.freeTools.whatDiscounts.answer"
      }),
      onExpandedChange: () => handleFaqToggle('freeTools.whatDiscounts', 'pricing-page-components.frequentlyAskedQuestions.freeTools.whatDiscounts.question')
    }), /*#__PURE__*/_jsx(ExpandingFAQ, {
      Title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "pricing-page-components.frequentlyAskedQuestions.freeTools.whenEligibleForNewPricing.question"
      }),
      Content: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "pricing-page-components.frequentlyAskedQuestions.freeTools.whenEligibleForNewPricing.answer"
      }),
      onExpandedChange: () => handleFaqToggle('freeTools.whenEligibleForNewPricing', 'pricing-page-components.frequentlyAskedQuestions.freeTools.whenEligibleForNewPricing.question')
    })]
  });
};